export default "__VITE_ASSET__BFGQsSV$__"